import React, { useState, useRef } from 'react'
import classNames from 'classnames'

import './decile.scss'

const DECILE_DOTS = [0, 10, 20, 30, 40, 50, 60, 70, 80]
const DECILE_SIZE = 5.7

const Decile = ({ decile = [0, 0], updateDecile }) => {
  const activeDecile = useRef(null)

  const handleMouseDown = (dec) => (event) => {
    event.preventDefault()
    if (decile.includes(dec)) activeDecile.current = dec
  }

  const handleMouseUp = (dec) => (event) => {
    event.preventDefault()
    const currentDecile = activeDecile.current
    activeDecile.current = null
    if (currentDecile === null) return

    const newDecile = [...decile]
    const index = newDecile.indexOf(currentDecile)
    newDecile[index] = dec
    newDecile.sort((a, b) => a - b)
    updateDecile(newDecile)
  }

  return (
    <div className="decile">
      <div className="decile__header">
        <div className="decile__header-title">Decile</div>
        <div className="decile__header-range-info">
          <b>Top {decile[0]}%</b>
          <span>to</span>
          <b>Top {decile[1]}%</b>
        </div>
        <div className="decile__header-size-info">
          <span>
            Estimated size:{' '}
            <b className="decile__header-size-info-text">
              {((decile[1] - decile[0]) * DECILE_SIZE) / 10}M
            </b>
          </span>
        </div>
      </div>
      <div className="decile__body">
        <div className="decile__range">
          {DECILE_DOTS.map((dec) => (
            <div
              key={dec}
              className="decile__dot-container"
              onMouseDown={handleMouseDown(dec)}
              onMouseUp={handleMouseUp(dec)}
            >
              <span
                className={classNames('decile__dot', {
                  'decile__dot--active': decile.includes(dec),
                })}
              ></span>
            </div>
          ))}
        </div>
        <div
          className="decile__line"
          style={{
            '--decile-line-start': `${(decile[0] / DECILE_DOTS.at(-1)) * 100}%`,
            '--decile-line-end': `${(decile[1] / DECILE_DOTS.at(-1)) * 100}%`,
          }}
        ></div>
      </div>
    </div>
  )
}

export default Decile
